import { Dispatch, SetStateAction, useState } from "react";
import FeedbackModal from "./feedback-modal";
import { Stars } from "./feedback-stars";

type TFeedbackRatingProps = {
	setHasSubmittedFeedback: Dispatch<SetStateAction<boolean>>;
};

const FeedbackRating = ({ setHasSubmittedFeedback }: TFeedbackRatingProps) => {
	const [currentRating, setCurrentRating] = useState<number>(0);
	const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState<boolean>(false);

	const handleRatingChange = (newRating: number) => {
		setIsFeedbackModalOpen(true);
		setCurrentRating(newRating);
	};

	const onSubmit = () => {
		setHasSubmittedFeedback(true);
	};

	return (
		<>
			<Stars rating={currentRating} setRating={handleRatingChange} />
			<FeedbackModal
				isModalOpen={isFeedbackModalOpen}
				closeModal={() => {
					setCurrentRating(0);
					setIsFeedbackModalOpen(false)
				}}
				currentRating={currentRating}
				onRating={handleRatingChange}
				onSubmit={onSubmit}
			/>
		</>
	);
};

export default FeedbackRating;
